import { toast } from 'sonner';

import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Group } from '../models/group';
import { endpointName } from './const';

export const getAllGroups = async (): Promise<Group[]> => {
    try {
        const response = await getHttpClient().get<Group[]>({ url: endpointName });
        const groupList: Group[] = [];

        if (response) {
            response.forEach((group) => groupList.push(group));
            return groupList;
        }

        toast.error('Brak danych.');
        throw new Error('No group data received.');
    } catch (error) {
        toast.error(`Błąd podczas pobierania danych: ${error}`);
        throw error;
    }
};
